// Mutation types
export const MTYPES = {
  ADD_GRIDFORM: 'ADD_GRIDFORM',
  UPDATE_GRIDFORM: 'UPDATE_GRIDFORM',
  APPLY_CHANGES: 'APPLY_CHANGES',
  CONFIG_GRIDFORM: 'CONFIG_GRIDFORM',
  RESET_GRIDFORM: 'RESET_GRIDFORM',

  SET_PERMISSION: 'SET_PERMISSION',

  SET_AUTOCOMPLETE_DATA: 'SET_AUTOCOMPLETE_DATA',
  MARK_FAILED_LOAD: 'MARK_FAILED_LOAD',

  ADD_FORM: 'ADD_FORM',
  SET_ROWS: 'SET_ROWS',
  CLEAR_ROWS: 'CLEAR_ROWS',
  ADD_ROW: 'ADD_ROW',
  ADD_ROWS: 'ADD_ROWS',
  MOVE_ROW: 'MOVE_ROW',
  REMOVE_FIELD: 'REMOVE_FIELD',
  SET_FIELDS: 'SET_FIELDS',
  SET_FIELDLISTS: 'SET_FIELDLISTS',
  SET_FIELDLISTS_RATING: 'SET_FIELDLISTS_RATING',
  SET_FIELDLISTS_FOCUS: 'SET_FIELDLISTS_FOCUS',
  SET_FIELDLISTS_GROUPED: 'SET_FIELDLISTS_GROUPED',

  CHECK_WATCHER: 'CHECK_WATCHER',

  CONFIG_FIELD: 'CONFIG_FIELD',
  UPDATE_FIELD_DATA: 'UPDATE_FIELD_DATA',
  UPDATE_FIELDLIST: 'UPDATE_FIELDLIST',
  UPDATE_FIELDLISTS: 'UPDATE_FIELDLISTS',
  RELOAD_GRIDFORM: 'RELOAD_GRIDFORM',
  DELETE_GRIDFORM: 'DELETE_GRIDFORM'
}

// Action types
export const ATYPES = {
  GFADD: 'GFADD',
  GFCHANGE: 'GFCHANGE',
  GFUPDATE: 'GFUPDATE',
  GFDATA: 'GFDATA',
  GFFIELDLIST: 'GFFIELDLIST',
  GFFIELDLISTS: 'GFFIELDLISTS',
  GFFIELDLISTSRATING: 'GFFIELDLISTSRATING',
  GFCONFIG: 'GFCONFIG',
  GFRESET: 'GFRESET',
  GFFINDREF: 'GFFINDREF',
  GFPERMISSION: 'GFPERMISSION',
  GFADDROWS: 'GFADDROWS',
  GFSETROWS: 'GFSETROWS',
  GFMOVEROW: 'GFMOVEROW',
  GFFIELD: 'GFFIELD',
  GFRELOAD: 'GFRELOAD',
  GFDELETE: 'GFDELETE',
  GFDELETEALL: 'GFDELETEALL',
  REMOVE_FIELD: 'REMOVE_FIELD',
  ROLLBACK: 'ROLLBACK'
}

export const MAP_GETTERS = [
  'global',
  'permissions',
  'dark',
  'size',
  'fieldstyle',
  'stacked',
  'elevation'
]
